<template>
    <v-autocomplete
            :box="!noBox"
            v-model="model"
            :items="communes"
            item-text="name"
            item-value="id"
            label="Seleccionar Comuna"
            :prepend-inner-icon="noIcon ? '' : 'mdi-city'"
            clearable
            @click:clear="clear"
            return-object
            :multiple="multiple==true"
            :rules="requiredRules"
            :readonly="readonly"
    >
        <template v-if="multiple==true" v-slot:selection="{ item, index }">
            <v-chip small v-if="index === 0">
                <span>{{ item.name }}</span>
            </v-chip>
            <span
                v-if="index === 1"
                class="grey--text caption"
            >({{ model.length - 1 }}+)</span>
        </template>
    </v-autocomplete>
</template>

<script>
    import {mapState} from 'vuex'
    export default{
        props: ['onChange', 'default', 'multiple', 'noBox', 'required', 'noIcon', 'readonly'],
        data(){
            return {
                model: this.default || null,
                requiredRules: [
                    v => !!v || 'Campo requerido'
                ],
            }
        },
        watch:{
            model(val){
                if(typeof this.onChange == 'function'){
                    this.onChange(val)
                }
            }
        },
        methods: {
          clear(){
              this.model = []
          }
        },
        computed: {
            ...mapState(['regions']),
            communes(){
                var all = []
                this.regions.forEach(region => {

                    all.push({
                        header: region.name
                    })

                    region.communes.forEach(commune => {
                        all.push({
                            id: commune.id,
                            name: commune.name
                        })
                    })

                })

                return all

            }
        }
    }
</script>